import React, { useState, useEffect } from 'react'
import Course from '../../components/registerRound/Course'
import Scores from '../../components/registerRound/Scores';
import { apiFetch } from "api";
import { useAuth } from "../../AuthContext";

export default function AddRound() {

    const [scoresData, setScoresData] = useState([]);
    const [clearAllScores, setClearAllScores] = useState(false);
    const [players, setPlayers] = useState([]);
    const [avaliableSeasons, setAvaliableSeasons] = useState([]);
    const [season, setSeason] = useState({});
    const [club, setClub] = useState({})
    const [course, setCourse] = useState({});
    const [tee, setTee] = useState({});
    const [date, setDate] = useState('');
    const [signatureEvent, setSignatureEvent] = useState(false);
    const [eventName, setEventName] = useState("");
    const [toast, setToast] = useState(null);

    const { player } = useAuth();

    // temp
    const leagueId = player?.leagues[0] ? player?.leagues[0] : "p7rV0fyVsJqBFtysklEj"


    useEffect(() => {

        const fetchData = async () => {
            try {
                const res = await apiFetch(`/league/${leagueId}/seasons`)

                if (!res.ok) {
                    throw new Error(`HTTP error! Status: ${res.status}`);
                }

                let data = await res.json();
                setAvaliableSeasons(data)
                setSeason(data[0])

            } catch (err) {
                console.log("Failed to fetch league players.", err)
            }

        }
        fetchData();

    }, [clearAllScores])

    useEffect(() => {

        const fetchData = async () => {
            try {
                const res = await apiFetch(`/league/${leagueId}/members?active=true`)

                if (!res.ok) {
                    throw new Error(`HTTP error! Status: ${res.status}`);
                }

                let data = await res.json();
                data.sort((a, b) => a.firstName.localeCompare(b.firstName))

                setPlayers(data)

            } catch (err) {
                console.log("Failed to fetch league players.", err)
            }

        }
        fetchData();

    }, [clearAllScores])






    useEffect(() => {
        if (!toast) return;
        const timer = setTimeout(() => setToast(null), 4000);
        return () => clearTimeout(timer);
    }, [toast]);

    const submitScore = async () => {
        const missingFields = [];
        if (!club || !club.name) missingFields.push("Klubb");
        if (!course || !course.name) missingFields.push("Bana");
        if (!tee || !tee.name) missingFields.push("Tee");
        if (!season || !season.id) missingFields.push("Säsong");

        if (missingFields.length > 0) {
            setToast({ message: `Följande val saknas: ${missingFields.join(", ")}`, type: "error" });
            return;
        }

        const roundData = {
            club: club.name,
            course: course.name,
            tee: tee.name,
            date,
            signatureEvent,
            eventName,
            playerScores: scoresData,
            seasonId: season.id,
            leagueId: leagueId
        };

        try {
            const res = await apiFetch(`/league/${leagueId}/round`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(roundData)
            });

            if (!res.ok) {
                const data = await res.json().catch(() => ({}));
                setToast({ message: data.error || "Något gick fel, försök igen.", type: "error" });
                return;
            }

            setToast({ message: "Omgången sparades!", type: "success" });
            setCourse({});
            setScoresData([]);
            setClearAllScores(true);
            setTimeout(() => setClearAllScores(false), 0);
        } catch (err) {
            console.error("Failed to post round", err);
            setToast({ message: "Något gick fel, försök igen.", type: "error" });
        }
    }

    return (
        <div>
            {toast && (
                <div className={`toast toast--${toast.type}`}>
                    {toast.message}
                </div>
            )}
            <Course
                leagueName="SVÄRMORSDRÖMMAR"
                clearAllScores={clearAllScores}
                season={season}
                setSeason={setSeason}
                club={club}
                setClub={setClub}
                avaliableSeasons={avaliableSeasons}
                course={course}
                setCourse={setCourse}
                tee={tee}
                setTee={setTee}
                date={date}
                setDate={setDate}
                signatureEvent={signatureEvent}
                setSignatureEvent={setSignatureEvent}
                eventName={eventName}
                setEventName={setEventName}

            />
            <Scores
                scoresData={scoresData}
                setScoresData={setScoresData}
                players={players}
                clearAllScores={clearAllScores}
                saveRound={submitScore}

            />

        </div>
    )
}
